import { makeAutoObservable, action } from 'mobx';

export enum LeftMenuState {
    LEFT_MENU_1 = "LEFT_MENU_1",
    LEFT_MENU_2 = "LEFT_MENU_2",
    LEFT_MENU_3 = "LEFT_MENU_3",
    LEFT_MENU_4 = "LEFT_MENU_4",
    LEFT_MENU_5 = "LEFT_MENU_5",
    LEFT_MENU_6 = "LEFT_MENU_6",
    LEFT_MENU_7 = "LEFT_MENU_7",
    LEFT_MENU_8 = "LEFT_MENU_8",
    LEFT_MENU_9 = "LEFT_MENU_9",
    LEFT_MENU_10 = "LEFT_MENU_10",
    LEFT_MENU_11 = "LEFT_MENU_11",
    LEFT_MENU_12 = "LEFT_MENU_12",
    LEFT_MENU_13 = "LEFT_MENU_13",
    LEFT_MENU_14 = "LEFT_MENU_14",
    LEFT_MENU_15 = "LEFT_MENU_15",
}

class HomeMenuStore {
    menuState: LeftMenuState | null = null; // observable 상태

    constructor() {
        makeAutoObservable(this, {
            setMenuState: action,
            selectByIndex: action,
            resetMenuState: action,
        });
        // 초기 1회 복원: 렌더 중 변경 방지
        const saved = localStorage.getItem('menuState') as LeftMenuState | null;
        if (saved && Object.values(LeftMenuState).includes(saved as LeftMenuState)) {
            this.menuState = saved as LeftMenuState;
        }
    }

    // 상태를 변경하는 메서드
    setMenuState(newState: LeftMenuState | null) {
        const prevState = this.menuState;
        this.menuState = newState;

        if (newState !== null) {
            localStorage.setItem("menuState", newState);
        } else {
            localStorage.removeItem("menuState");
        }
    }

    // 상태 확인 메서드
    getMenuState(): LeftMenuState | null {
        return this.menuState;
    }

    getSelectedIndex(): number | null {
        if (this.menuState === null) return null;
        return Object.values(LeftMenuState).indexOf(this.menuState);
    }

    selectByIndex(index: number) {
        const states = Object.values(LeftMenuState);
        if (index >= 0 && index < states.length) {
            this.setMenuState(states[index]);
        } else {
            console.warn(`❌ 잘못된 인덱스: ${index}`);
        }
    }

    getSelectionName(): string {
        switch (this.menuState) {
            case LeftMenuState.LEFT_MENU_1:
            case LeftMenuState.LEFT_MENU_2:
            case LeftMenuState.LEFT_MENU_3:
            case LeftMenuState.LEFT_MENU_4:
            case LeftMenuState.LEFT_MENU_5:
                return '홈페이지 관리'
            case LeftMenuState.LEFT_MENU_6:
            case LeftMenuState.LEFT_MENU_7:
            case LeftMenuState.LEFT_MENU_8:
            case LeftMenuState.LEFT_MENU_9:
                return '게시판 컨텐츠 관리'
            case LeftMenuState.LEFT_MENU_10:
                return '계정 및 보안 관리'
            case LeftMenuState.LEFT_MENU_11:
            case LeftMenuState.LEFT_MENU_12:
            case LeftMenuState.LEFT_MENU_13:
            case LeftMenuState.LEFT_MENU_14:
            case LeftMenuState.LEFT_MENU_15:
                return '아카이브'
            default:
                return ''
        }
    }

    getSelectedItemName(): string {
        switch (this.menuState) {
            case LeftMenuState.LEFT_MENU_1:
                return '문의하기 관리';
            case LeftMenuState.LEFT_MENU_2:
                return 'BB열린소리 관리';
            case LeftMenuState.LEFT_MENU_3:
                return '담당자 관리'
            case LeftMenuState.LEFT_MENU_4:
                return '홈페이지 정보 관리'
            case LeftMenuState.LEFT_MENU_5:
                return '홈페이지 유지보수 요청'
            case LeftMenuState.LEFT_MENU_6:
                return '홍보 게시판 관리'
            case LeftMenuState.LEFT_MENU_7:
                return '채용공고 게시판 관리'
            case LeftMenuState.LEFT_MENU_8:
                return '특허 게시판 관리'
            case LeftMenuState.LEFT_MENU_9:
                return '공지사항 게시판 관리'
            case LeftMenuState.LEFT_MENU_10:
                return '관리자 계정 관리'
            case LeftMenuState.LEFT_MENU_11:
                return 'BB게시판'
            case LeftMenuState.LEFT_MENU_12:
                return '사내전용게시판'
            case LeftMenuState.LEFT_MENU_13:
                return 'BB갤러리'
            case LeftMenuState.LEFT_MENU_14:
                return '사내전용갤러리'
            case LeftMenuState.LEFT_MENU_15:
                return '게시판 백업'

            default:
                return ''
        }
    }

    resetMenuState() {
        localStorage.removeItem("menuState");
        this.menuState = null;
    }
}

export const homeMenuStore = new HomeMenuStore();